import React from 'react';
import { FiX, FiShoppingBag, FiStar } from 'react-icons/fi';
import './ProductModal.css';

const ProductModal = ({ product, onClose }) => {
  if (!product) return null;

  const image =
    (Array.isArray(product.images) && product.images.length > 0 && product.images[0]) ||
    product.image ||
    'https://via.placeholder.com/800x600';

  const discountPercent =
    Number(product.discount_percent ?? product.discount) ||
    (product.compare_price && product.price
      ? Math.round((1 - Number(product.price) / Number(product.compare_price)) * 100)
      : 0);

  const hasDiscount = discountPercent > 0;

  return (
    <div className="product-modal-overlay" onClick={onClose}>
      <div className="product-modal" onClick={(e) => e.stopPropagation()}>
        <button className="product-modal-close" onClick={onClose} aria-label="Cerrar">
          <FiX />
        </button>

        <div className="product-modal-body">
          <div className="product-modal-media">
            <img src={image} alt={product.name} />
            {hasDiscount && <span className="product-modal-discount">-{discountPercent}%</span>}
          </div>

          <div className="product-modal-content">
            <div className="product-modal-meta">
              {(product.category_name || product.category) && (
                <span className="product-modal-category">{product.category_name || product.category}</span>
              )}
              {product.rating != null && (
                <span className="product-modal-rating">
                  <FiStar /> {product.rating}
                </span>
              )}
            </div>

            <h2 className="product-modal-title">{product.name}</h2>

            {(product.short_description || product.description) && (
              <p className="product-modal-description">{product.short_description || product.description}</p>
            )}

            <div className="product-modal-price">
              {hasDiscount ? (
                <>
                  <span className="product-modal-price-original">
                    ${product.compare_price || product.price}
                  </span>
                  <span className="product-modal-price-current">${product.price}</span>
                </>
              ) : (
                <span className="product-modal-price-current">${product.price}</span>
              )}
            </div>

            <button className="product-modal-cta" type="button" onClick={(e) => e.preventDefault()}>
              <FiShoppingBag /> Añadir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
